// extracted by mini-css-extract-plugin
module.exports = {"swiper":"pure-ads_swiper__u6W6B"};